module.exports = __webpack_public_path__ + "static/img/gaozhongshengwu.540d2d75.jpg";